import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: { // Exercise num
    // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P38-E1",
    audio: "img/FriendsPlus/Page38/Audio/audio-e2-p38.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page38/E1/1.jpg" }],
      [{ url: 'img/FriendsPlus/Page38/E1/2.jpg' }],
      [
        // Column3
        { url: 'img/FriendsPlus/Page38/E1/3.jpg' },
        { url: 'img/FriendsPlus/Page38/E1/4.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh1-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page38/E1/6.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh2-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page38/E1/8.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh3-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E1/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page38/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page38/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page38/E1/12.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh4-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page38/E1/14.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh5-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page38/E1/16.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh6-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E1/17.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page38/E1/18.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 5',
    id: 'SB3-U5-P38-E2',
    audio: 'img/FriendsPlus/Page38/Audio/audio-e2-p38.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page38/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/2.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/tieude-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page38/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page38/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/6.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh1-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/8.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh2-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/10.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh3-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E2/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page38/E2/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page38/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/14.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh4-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/16.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh5-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page38/E2/18.jpg', audioUrl: "img/FriendsPlus/Page38/Audio/hinh6-e2-p38.mp3" },
        { url: 'img/FriendsPlus/Page38/E2/19.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page38/E2/20.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 5',
    id: 'SB3-U5-P37-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page38/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read again. Circle the correct word.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        // initialWordStyle: { margin: '5px 0', border: 'solid 2px', borderColor: 'black', borderRadius: '50%', padding: '0 5px' },
        initialWordStyle: { margin: '5px 0', border: 'none', borderColor: 'transparent', borderRadius: '50%', fontWeight: 'bold' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', padding: '0 5px' },
        limitSelect: 1,
        listWords: [
          'cake / card',//0
          'close / open',//1
          'Grandpa / you',//2
          'write / talk',//3
          'mom / dad',//4
        ],
        answers: ['0-4', '1-4', '2-4', '3-0', '4-0'],
        initialValue: ['0-4'],
      },
      Layout: `
        <div>
          <img src="img/FriendsPlus/Page38/E3/1.jpg" >
          <div>1 Draw a picture on the front of the <input id='0' type='Circle' />.</div>
          <div>2 Now <input id='1' type='Circle' /> the card.</div>
          <div>3 Draw a picture of <input id='2' type='Circle' />.</div>
          <div>4 Now <input id='3' type='Circle' /> on the card.</div>
          <div>5 Give the card to your <input id='4' type='Circle' />.</div>
        </div>
      `,
    },
  },
}

export default json;
